import React, { useEffect, useState } from 'react';
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import Header2 from '../component/common/title';
import AddCTA from '../component/common/addcta';
import './sec-event.css'
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic27 from '../assets/pic27.png'
import pic28 from '../assets/pic28.png'
import pic30 from '../assets/pic30.png'
import pic31 from '../assets/pic31.png'
import pic32 from '../assets/pic32.png'
import { supabase } from '../supabase';
import Input from '../component/common/input';
import Select from '../component/common/select';
import { useRef } from "react";
import pic34 from '../assets/pic34.png'
import pic35 from '../assets/pic35.png'





const Sec1event = () => {

const [Events, setEvents] = useState([]);
const [showForm, setShowForm] = useState(false);
const [selectedFile, setSelectedFile] = useState(null);
const [search, setSearch] = useState('');
const [filter, setFilter] = useState('');
const [sort, setSort] = useState('');
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [selectedDeleteId, setSelectedDeleteId] = useState(null);
const [isEditing, setIsEditing] = useState(false);
const [editingId, setEditingId] = useState(null);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [categories, setCategories] = useState([]);

const [formData, setFormData] = useState({
  Event_title: '',
    Event_title_ar: '',
    artist: '',
    artist_ar: '', 
  category: '',
  Availability_status: '',
  Availability_status_ar: '',
  start_time: '',
  end_time: '',
  Data: '',
  location: '',
    Location_ar: '', 
  starting_price: '',
  max_price: '',
  Description: '',
    Description_ar: '',
  Image: null
});









useEffect(() => {
  const getAllEvents = async () => {
    const { data, error } = await supabase.from('Events').select(`
      *,
      Events_Categories(
        Categories:Category_id (
          id,
          Category_name,
           Category_name_ar
        )
      )
    `);

    if (error) {
      console.log("EVENTS FETCH ERROR:", error);
      return;
    }

    setEvents(data || []);
  };




  
  const fetchCategories = async () => {
    const { data, error } = await supabase
      .from('Categories')
  .select('id, Category_name, Category_name_ar');

    if (error) {
      console.log("CATEGORIES FETCH ERROR:", error);
      return;
    }

    setCategories(data || []);
  };

  getAllEvents();
  fetchCategories();
}, []);













const filteredEvents = Events
  .filter((item) => {
    const matchesSearch =
      item.Event_title?.toLowerCase().includes(search.toLowerCase());


    let matchesFilter = true;


if (filter.startsWith('category')) {
  const selectedCategoryId = filter.split('-')[1];

  matchesFilter = item.Events_Categories?.some((ec) =>
    String(ec.Categories?.id) === String(selectedCategoryId)
  );
}


if (filter === 'status-limited') {
  matchesFilter = item.Availability_status === 'Limited';
}

if (filter === 'status-available') {
  matchesFilter = item.Availability_status === 'Available';
}
    return matchesSearch && matchesFilter;
  })
  .sort((a, b) => {

if (sort === 'newest') {
  return new Date(a.Data) - new Date(b.Data);
}

if (sort === 'oldest') {
  return new Date(b.Data) - new Date(a.Data);
}

if (sort === 'priceLow') {
  return Number(a.starting_price) - Number(b.starting_price);
}

if (sort === 'priceHigh') {
  return Number(b.starting_price) - Number(a.starting_price);
}
    return 0;
  });



    

  const inputRef = useRef(null);

  const handleClick = () => {
    inputRef.current.click();
  };



const handleClose = () => {
  setShowForm(false);
  setIsEditing(false);
  setEditingId(null);
  setFormData({
  Event_title: '',
  Event_title_ar: '',
  artist: '',
  artist_ar: '',
  category: '',
  Availability_status: '',
  Availability_status_ar: '',
  start_time: '',
  end_time: '',
  Data: '',
  location: '',
  Location_ar: '',
  starting_price: '',
  max_price: '',
  Description: '',
  Description_ar: '',
  Image: null
  });

};


const createEvent = async () => {
  const { data: eventData, error: eventError } = await supabase
    .from('Events')
    .insert([{
      Event_title: formData.Event_title,
      Event_title_ar: formData.Event_title_ar,
      artist: formData.artist,
       artist_ar: formData.artist_ar,
      Description: formData.Description,
       Description_ar: formData.Description_ar,
      Data: formData.Data,
      location: formData.location,
       Location_ar: formData.Location_ar,
      start_time: formData.start_time,
      end_time: formData.end_time,
      Availability_status: formData.Availability_status,
       Availability_status_ar: formData.Availability_status_ar,
      Image: formData.Image,
      starting_price: Number(formData.starting_price),
      max_price: Number(formData.max_price)
    }])
    .select();

  if (eventError) {
    console.error("CREATE EVENT ERROR:", eventError);
    alert("Failed to create event: " + eventError.message);
    return;
  }

  const eventId = eventData[0].id;

  if (formData.category) {
    await supabase.from('Events_Categories').insert([
      {
        Event_id: eventId,
        Category_id: formData.category
      }
    ]);
  }

  const { data: updatedEvents, error } = await supabase.from('Events').select(`
    *,
    Events_Categories(
      Categories:Category_id (
        id,
        Category_name,
      Category_name_ar 
      )
    )
  `);

  if (error) {
    console.log("REFRESH ERROR:", error);
    return;
  }

  setEvents(updatedEvents || []);
  handleClose();
};









const confirmDelete = async () => {
  const id = selectedDeleteId;

  await supabase.from('Events_Categories').delete().eq('Event_id', id);
        await supabase.from('Booking').delete().eq('Event_id', id);
  await supabase.from('Events').delete().eq('id', id);

  setEvents(prev => prev.filter(event => event.id !== id));

  setShowDeleteModal(false);
  setSelectedDeleteId(null);
};







const handleEditClick = (item) => {
  setFormData({
    Event_title: item.Event_title || '',
      Event_title_ar: item.Event_title_ar || '',
    artist: item.artist || '',
      artist_ar: item.artist_ar || '',
    category: item.Events_Categories?.[0]?.Categories?.id || '',
    Availability_status: item.Availability_status || '',
     Availability_status_ar: item.Availability_status_ar || '',
    start_time: item.start_time || '',
    end_time: item.end_time || '',
    Data: item.Data || '',
    location: item.location || '',
    Location_ar: item.Location_ar || '',
    starting_price: item.starting_price || '',
    max_price: item.max_price || '',
    Description: item.Description || '',
    Description_ar: item.Description_ar || '',
    Image: item.Image || ''
  });


  setEditingId(item.id);
  setIsEditing(true);
  setShowForm(true);
};











const updateEvent = async () => {
  const id = editingId;

  const { error: eventError } = await supabase
    .from('Events')
    .update({
      Event_title: formData.Event_title,
        Event_title_ar: formData.Event_title_ar,
      artist: formData.artist,
        artist_ar: formData.artist_ar,
      Description: formData.Description,
        Description_ar: formData.Description_ar,
      Data: formData.Data,
      location: formData.location,
       Location_ar: formData.Location_ar,
      start_time: formData.start_time,
      end_time: formData.end_time,
      Availability_status: formData.Availability_status,
      Availability_status_ar: formData.Availability_status_ar,
      Image: formData.Image,
      starting_price: Number(formData.starting_price),
      max_price: Number(formData.max_price)
    })
    .eq('id', id);

  if (eventError) {
    console.error("UPDATE EVENT ERROR:", eventError);
    return;
  }

  await supabase.from('Events_Categories').delete().eq('Event_id', id);

  if (formData.category) {
    await supabase.from('Events_Categories').insert([
      {
        Event_id: id,
        Category_id: formData.category
      }
    ]);
  }

  const { data: updatedEvents, error } = await supabase.from('Events').select(`
    *,
    Events_Categories(
      Categories:Category_id (
        id,
        Category_name,
      Category_name_ar 
      )
    )
  `);

  if (error) {
    console.log("REFRESH ERROR:", error);
    return;
  }

  setEvents(updatedEvents || []);
  handleClose();
};


const statusMap = {
  Available: 'متاح',
  Limited: 'محدود'
};

const reverseStatusMap = {
  'متاح': 'Available',
  'محدود': 'Limited'
};













    return ( 
 <section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                    <section className='information-container'>
                        <article className='header-cont-event'>
                           <Header2 
                            title="Events Management"  
                            para="Manage all your events and ticket listings."
                            />
                          <AddCTA    title='Add Events'   onClick={() => setShowForm(true)} />
                        
                        </article>



{showForm && (
  <div className="overlay-create">
    <div className="container-create">

      <div className="header-create">
            <h1 className="title-create">
            {isEditing ? 'Edit Event' : 'Add New Event'}
            </h1>

        <button
          className="close-btn-create"
          onClick={handleClose}
          type="button"
        >
          <img src={pic34} alt='close' />
        </button>
      </div>




      <form className="form-create"   onSubmit={async (e) => {
    e.preventDefault();
    try {
        if (isEditing) {
            await updateEvent();
        } else {
            await createEvent();
        }
    } catch (err) {
        console.error(err);
    }
        }}>

                                <fieldset className="field-group-create">
                                    <Input
                                        title='Event Name'
                                        placeholder='Enter event name'
                                        type="text"
                                          value={formData.Event_title}
                                        onChange={(e) =>
                                            setFormData({ ...formData, Event_title: e.target.value })
                                        }
                                    />
                                </fieldset>


                                <fieldset className="field-group-create">

                                      <Input
                                        title='Event Name (Arabic)'
                                        placeholder='Enter Arabic name'
                                        type="text"
                                        value={formData.Event_title_ar}
                                        onChange={(e) =>
                                          setFormData({ ...formData, Event_title_ar: e.target.value })
                                        }
                                      />

  
                                </fieldset>

                                <fieldset className="field-group-create">
                                  <Input
                                    title="Artist Name"
                                    placeholder="Enter artist name"
                                    type="text"
                                    value={formData.artist}
                                    onChange={(e) =>
                                      setFormData({ ...formData, artist: e.target.value })
                                    }
                                  />
                                  <Input
                                      title='Artist Name (Arabic)'
                                      placeholder='Enter Arabic artist'
                                      type="text"
                                      value={formData.artist_ar}
                                      onChange={(e) =>
                                        setFormData({ ...formData, artist_ar: e.target.value })
                                      }
                                    />
                                </fieldset>


                                <fieldset className="field-group-create">
                                    <fieldset className="fieldset">
                                      <label className='title-input'>Category</label>
                                      <div className="select-wrapper2">
                                        <img src={pic28} className="arrow-icon2" alt="arrow" />
                                        <select
                                          className="input-search2 select-style2"
                                          value={formData.category}
                                          onChange={(e) =>
                                            setFormData({ ...formData, category: e.target.value })
                                          }
                                        >
                                          <option value="">Select Category</option>
                                          {categories.map((cat) => (
                                            <option key={cat.id} value={cat.id}>
                                              {cat.Category_name}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </fieldset>
                                    </fieldset>


                                    {/* <fieldset className="fieldset">
                                      <label className='title-input'>Category (Arabic)</label>
                                      <div className="select-wrapper2">
                                        <img src={pic28} className="arrow-icon2" alt="arrow" />

                                        <select
                                          className="input-search2 select-style2"
                                          value={formData.category}
                                          onChange={(e) =>
                                            setFormData({ ...formData, category: e.target.value })
                                          }
                                        >
                                          <option value="">Select Category</option>
                                          {categories.map((cat) => (
                                            <option key={cat.id} value={cat.id}>
                                              {cat.Category_name_ar}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </fieldset> */}



                                <fieldset className="field-group-create">
                                    <Select title='Status'  select1='Limited' select2='Available'   value={formData.Availability_status}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        setFormData({
                                          ...formData,
                                          Availability_status: value,
                                           Availability_status_ar: value ? statusMap[value] : ''
                                        });
                                      }}
                                    />


                                    {/* <fieldset className="fieldset">
                                      <label className='title-input'>Status (Arabic)</label>
                                      <div className="select-wrapper2">
                                        <img src={pic28} className="arrow-icon2" alt="arrow" />
                                        
                                        <select
                                          className="input-search2 select-style2"
                                          value={formData.Availability_status_ar}
                                                onChange={(e) => {
                                                  const value = e.target.value;

                                                  setFormData({
                                                    ...formData,
                                                    Availability_status_ar: value,
                                                    Availability_status: value ? reverseStatusMap[value] : ''
                                                  });
                                                }}
                                        >
                                          <option value="">Sort by</option>
                                          <option value="متاح">متاح</option>
                                          <option value="محدود">محدود</option>
                                        </select>
                                      </div>
                                    </fieldset> */}
                                </fieldset>

                                
                                        <fieldset className="field-group-create">
                                    <Input
                                        title='Starting Time'
                                        placeholder='choose time'
                                        type="time"
                                          value={formData.start_time}
                                            onChange={(e) =>
                                                setFormData({ ...formData, start_time: e.target.value })
                                            }
                                    />
                                                <Input
                                        title='Ending Time'
                                        placeholder='choose time'
                                        type="time"
                                          value={formData.end_time}
                                        onChange={(e) =>
                                            setFormData({ ...formData, end_time: e.target.value })
                                        }
                                    />
                                </fieldset>
                                <fieldset className="field-group-create">
                                    <Input
                                        title='Date'
                                        placeholder='choose date'
                                        type="date"
                                          value={formData.Data}
                                        onChange={(e) =>
                                            setFormData({ ...formData, Data: e.target.value })
                                        }
                                    />
                                </fieldset>

                                <fieldset className="field-group-create">
                                    <Input
                                        title='Location'
                                        placeholder='Event venue'
                                        type="text"
                                          value={formData.location}
                                            onChange={(e) =>
                                                setFormData({ ...formData, location: e.target.value })
                                            }
                                    />
                                    <Input
                                        title='Location (Arabic)'
                                        placeholder='Enter Arabic location'
                                        type="text"
                                        value={formData.Location_ar}
                                        onChange={(e) =>
                                          setFormData({ ...formData, Location_ar: e.target.value })
                                        }
                                      />
                                </fieldset>
                                <fieldset className="field-group-create">
                                    <Input
                                        title='Starting_price'
                                        placeholder='Enter amount'
                                        type="text"
                                          value={formData.starting_price}
                                            onChange={(e) =>
                                                setFormData({ ...formData, starting_price: e.target.value })
                                            }
                                    />
                                                <Input
                                        title='Max_price'
                                        placeholder='Enter amount'
                                        type="text"
                                          value={formData.max_price}
                                            onChange={(e) =>
                                                setFormData({ ...formData, max_price: e.target.value })
                                            }
                                    />
                                </fieldset>
                                <fieldset className="field-group-create">
                                    <fieldset className='container-text-area'>
                                            <h2 className='title-text-area'>Description</h2>
                                            <textarea className='main-text-area' placeholder='Event description'
                                              value={formData.Description}
                                                onChange={(e) =>
                                                    setFormData({ ...formData, Description: e.target.value })
                                                }>

                                            </textarea>
                                            <textarea
                                            className='main-text-area'
                                            placeholder='Arabic description'
                                            value={formData.Description_ar}
                                            onChange={(e) =>
                                              setFormData({ ...formData, Description_ar: e.target.value })
                                            }
                                          />
                                    </fieldset>
                                </fieldset>



                                    <fieldset className="field-group-create">
                                                 <fieldset className='container-text-area'>
                                                    <h2 className="title-selecttt">Image URL</h2>
                                                    <input
                                                      type="text"
                                                      placeholder="Paste image URL here"
                                                      value={formData.Image || ''}
                                                      onChange={(e) =>
                                                        setFormData({ ...formData, Image: e.target.value })
                                                      }
                                                      className="input-search2"
                                                    />
                                                    {formData.Image && (
                                                      <img src={formData.Image} alt="preview" className="preview-image-create" />
                                                    )}
                                                  </fieldset>
                            </fieldset>



                                                        <nav className='container-ctas-craete'>
                                                                                    <button   type="button" className="cta-cancel-create" onClick={handleClose}>
                                                                                        <h2 className="cta-cancel-text-create">
                                                                                            Cancel
                                                                                        </h2>
                                                                                    </button>
                                                    
                                                                                    <button type="submit" className='cta-create'>
                                                                                    <h2 className='cta-create-text'>
                                                                                        {isEditing ? 'Edit Event' : 'Create Event'}
                                                                                    </h2>
                                                                                    </button>
                                                        </nav>
                                

      </form>
    </div>
  </div>
)}






{showDeleteModal && (
  <section className="delete-modal-overlay">
    <article className="delete-modal" role="dialog" aria-modal="true">
      
      <header className="delete-modal-header">
        <div className="delete-icon-wrapper">
          <img src={pic35} alt='icon'></img>
        </div>

        <div className="delete-text-container">
          <h2 className="delete-title">Delete Event</h2>
          <p className="delete-description">
            Are you sure you want to delete this event? This action cannot be undone.
          </p>
        </div>
      </header>

      <nav className="delete-modal-actions">
        <button
          className="delete-btn-cancel"
          onClick={() => {
            setShowDeleteModal(false);
            setSelectedDeleteId(null);
          }}
        >
          Cancel
        </button>

        <button
          className="delete-btn-confirm"
          onClick={confirmDelete}
        >
          Delete
        </button>
      </nav>

    </article>
  </section>
)}






                        <section className='container-table-eventp'>
                            <fieldset className="input-wrapper">
                                <input 
                                  className='input-search'
                                    placeholder="Search events..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                                <img src={pic25} className="search-icon" alt="search" />
                            </fieldset>
                            <fieldset className='container-inputs-event-p'>
                                  <div className="select-wrapper">
                                    <img src={pic28} className="arrow-icon" alt="arrow" />
                                    <img src={pic26} className="select-icon" alt="filter" />
                                <select
                                className="input-search select-style"
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                >
                                <option value="">Filter by</option>
                                {categories.map((cat) => (
                                  <option key={cat.id} value={`category-${cat.id}`}>
                                    {cat.Category_name}
                                  </option>
                                ))}
                                <option value="status-limited">Limited</option>
                                <option value="status-available">Available</option>
                                </select>
                                </div>


                                <div className="select-wrapper">
                                       <img src={pic28} className="arrow-icon" alt="arrow" />
                                    <img src={pic27} className="select-icon" alt="sort" />
                                    <select
                                    className="input-search select-style"
                                    value={sort}
                                    onChange={(e) => setSort(e.target.value)}
                                    >
                                    <option value="">Sort by</option>
                                    <option value="newest">Sort by date (Nearly upcoming)</option>
                                    <option value="oldest">Sort by date (Long-term)</option>
                                    <option value="priceLow">Sort by price (low → high)</option>
                                    <option value="priceHigh">Sort by price (high → low)</option>
                                    </select>
                                </div>

                            </fieldset>



                                                 <div className="table-container" >
                                <table className='table'>
                                    <thead>
                                    <tr className='table-header'>
                                        <th className='table-header-text'></th>
                                        <th className='table-header-text'>ID</th>
                                        <th className='table-header-text'>Event</th>
                                        <th className='table-header-text'>Category</th>
                                        <th className='table-header-text'>Date & Time</th>
                                        <th className='table-header-text'>Location</th>
                                        <th className='table-header-text'>Price</th>
                                        <th className='table-header-text'>Description</th>
                                        <th className='table-header-text'>Status</th>
                                        <th className='table-header-text'>Event_ar</th>  
                                         <th className='table-header-text'>Category_ar</th> 
                                          <th className='table-header-text'>Location_ar</th>   
                                           <th className='table-header-text'>Description_ar</th>
                                           <th className='table-header-text'>Availability_status_ar</th>                                                                                                                                                                                                                                                   
                                        <th className='table-header-text'>Actions</th>
                                    </tr>
                                    </thead>

 {filteredEvents.map((item) => { return <tbody key={item.id}>
                                            <tr className='table2-header'>
                                                <td className='checkbox-cont-table'>
                                                    <label className="custom-checkbox">
                                                    <input type="checkbox" />
                                                    <span className="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td className='mainwhite-table-font'>{item.id}</td>
                                                <td className='container-event3'>
                                                    <img className='img-tabel-event' src={item.Image} alt='pic'></img>
                                                    <div className='container-event2'>
                                                        <h2 className='event-title'>{item.Event_title}</h2>
                                                        <h3 className='artistname'>{item.artist}</h3>
                                                    </div>
                                                </td>
                                                <td className='mainwhite-table-font'>{item.Events_Categories?.map(e => e.Categories?.Category_name).join(', ')}</td>
                                                <td className='container-event'>
                                                    <div className='container-event2'>
                                                        <h2 className='event-title'>{item.Data}</h2>
                                                        <h3 className='artistname'>{item.start_time}- {item.end_time}</h3>
                                                    </div>
                                                </td>
                                            <td className="container-event-desc">
                                              <p className="truncate-text">
                                              {item.location}
                                              </p>
                                              </td>
                                            <td className='mainwhite2-table-font'>{item.starting_price}-{item.max_price}EGP</td>
                                                <td className="container-event-desc">
                                                <p className="truncate-text">
                                                   {item.Description}
                                                </p>
                                                </td>

                                                <td className='mainwhite-table-font'>
                                                    <div  className={`status-badge ${item.Availability_status?.toLowerCase() || ''}`}>
                                                    <div className='status-text'>{item.Availability_status}</div>
                                                    </div>
                                                </td>


                                                <td className='container-event3'>
                                                    <div className='container-event2'>
                                                        <h2 className='event-title-ar'>{item.Event_title_ar}</h2>
                                                        <h3 className='artistname_ar'>{item.artist_ar}</h3>
                                                    </div>
                                                </td>
                                                 <td className='mainwhite-table-font_ar'>{item.Events_Categories?.map(e => e.Categories?.Category_name_ar).join(', ')}</td>
                                            <td className="container-event-desc_ar">
                                              <p className="truncate-text">
                                              {item.Location_ar}
                                              </p>
                                              </td>
                                                <td className="container-event-desc_ar">
                                                <p className="truncate-text">
                                                   {item.Description_ar}
                                                </p>
                                                </td>
                                                <td className='mainwhite-table-font'>
                                                  <div className={`status-badge_ar ${item.Availability_status_ar || ''}`}>
                                                    <div className='status-text_ar'>
                                                      {item.Availability_status_ar}
                                                    </div>
                                                  </div>
                                                </td>

                                                
                                                <td className='mainwhite-table-font'>
                                                    <nav className='cta-table'>
                                                            <button className='cta2-table'>
                                                                <img src={pic30} alt='hide'></img>
                                                            </button>
                                                            <button
                                                            className='cta2-table'
                                                            onClick={() => handleEditClick(item)}
                                                            >
                                                            <img src={pic31} alt='edit' />
                                                            </button>
                                                            <button
                                                            className='cta2-table'
                                                            onClick={() => {
                                                                setSelectedDeleteId(item.id);
                                                                setShowDeleteModal(true);
                                                            }}
                                                            >
                                                            <img src={pic32} alt='delete' />
                                                            </button>
                                                            
                                                    </nav>
                                                </td>




                                            </tr>
                                    </tbody>
               })}
                                </table>
                                </div>

                                       




                        </section>







                    </section>

            </section>
        </section>
     );
}
 
export default Sec1event;